<template>
  <a-modal v-model:visible="modalConfig.visible" title="修改系列名称" @ok="updateSeriesName" @cancel="resetForm">
    <a-form ref="formRef" :label-col="{ style: { width: '100px' } }" :wrapper-col="{ style: { width: '300px' } }">
      <a-form-item label="系列1名称">
        <a-input v-model:value="modalConfig.seriesOneName" placeholder="请输入系列1名称"></a-input>
      </a-form-item>
      <a-form-item label="系列2名称">
        <a-input v-model:value="modalConfig.seriesTwoName" placeholder="请输入系列2名称"></a-input>
      </a-form-item>
      <a-form-item label="系列3名称">
        <a-input v-model:value="modalConfig.seriesThreeName" placeholder="请输入系列3名称"></a-input>
      </a-form-item>
      <a-form-item label="系列4名称">
        <a-input v-model:value="modalConfig.seriesFourName" placeholder="请输入系列4名称"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { FormOutlined, SaveOutlined } from "@ant-design/icons-vue";
import { saveBOMSerialName } from "@/request/view/project";
import { Toast, debounce } from "@/utils";

export default defineComponent({
  components: {
    FormOutlined,
    SaveOutlined,
  },
  props: {
    isProjectLeader: Boolean,
  },
  setup(props, context) {
    const route = useRoute();

    const formRef = ref();

    const modalConfig = reactive({
      visible: false,
      title: null,
      id: null,
      projectLifeCycleId: null,
      seriesFourName: null,
      seriesOneName: null,
      seriesThreeName: null,
      seriesTwoName: null
    });

    const resetForm = () => {
      Object.keys(modalConfig).forEach((key) => {
        modalConfig[key] = null;
      });
      modalConfig.visible = false;
    };

    const showModal = (data) => {
      Object.keys(data).forEach((key) => {
        modalConfig[key] = data[key];
      });
      modalConfig.projectLifeCycleId = route.query.projectId
    };

    const updateSeriesName = debounce(() => {
      saveBOMSerialName({
        id: modalConfig.id,
        seriesOneName: modalConfig.seriesOneName,
        seriesTwoName: modalConfig.seriesTwoName,
        seriesThreeName: modalConfig.seriesThreeName,
        seriesFourName: modalConfig.seriesFourName,
        projectLifeCycleId: modalConfig.projectLifeCycleId,
      })
        .then((res) => {

          const type = res.code === 200 ? "success" : "warning";

          Toast(type, res.message, 3);
          if (res.code === 400) return;
          resetForm();
          context.emit('handleUpdateColumns');
        })
        .catch((err) => { });
    });

    const handleUpdateSeriesName = () => {
      updateSeriesName();
    };


    return {
      props,
      modalConfig,
      updateSeriesName,
      resetForm,
      showModal,
      handleUpdateSeriesName,
    };
  },
});
</script>

<style lang="less" scoped></style>
